<template>
  <v-container>
    <v-progress-linear v-if="isLoading" indeterminate />
    <v-card>
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="6" md="5">
            <div class="text-subtitle-1 grey--text text--darken-1">Total del corte de caja</div>
            <h1 class="mt-1 primary--text">
              {{ total | formatCurrency }}
            </h1>
          </v-col>
          <v-col cols="12" sm="6" md="7" class="d-flex flex-wrap justify-end align-center" style="gap: 8px">
            <v-btn color="primary" depressed :loading="isGeneratingPDF" @click="downloadPDF(date)" class="pdf-btn">
              <v-icon left small>mdi-file-pdf-box</v-icon>
              Descargar reporte
            </v-btn>
            <v-btn color="primary" outlined @click="pdfDialog = true" class="pdf-btn">
              <v-icon left small>mdi-calendar-search</v-icon>
              Reporte de otro dia
            </v-btn>
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field class="input-date" color="primary" outlined dense hide-details v-model="date"
                  label="Fecha de corte" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable @change="cambio()" />
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Dialog para generar PDF de otra fecha -->
    <v-dialog v-model="pdfDialog" max-width="360">
      <v-card class="rounded-lg">
        <v-card-title class="text-subtitle-1 font-weight-bold primary--text pb-0">
          Generar reporte PDF
        </v-card-title>
        <v-card-text class="pt-3">
          <p class="text-body-2 grey--text text--darken-1 mb-3">Selecciona la fecha del corte que deseas exportar</p>
          <v-date-picker v-model="pdfDate" no-title full-width color="primary" />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn text @click="pdfDialog = false">Cancelar</v-btn>
          <v-btn color="primary" depressed :loading="isGeneratingPDF" @click="downloadPDF(pdfDate)">
            <v-icon left small>mdi-download</v-icon>
            Descargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="mt-4 corte-row">
      <v-col cols="12" md="3">
        <v-card class="d-flex flex-column fill-height">
          <v-card-text class="pb-0">
            <div class="d-flex flex-wrap align-center text-h6 text-md-h5">
              Usuarios Temporales
              <v-spacer />
              <span class="monto-total">{{ totalPlanTemporal | formatCurrency }}</span>
            </div>
          </v-card-text>
          <v-card-text class="flex-grow-1 pt-2">
            <div class="table-scroll">
              <v-simple-table class="corte-table">
                <template #default>
                  <thead>
                    <tr>
                      <th class="text-left">Código</th>
                      <th class="text-center">Cliente</th>
                      <th class="text-center">Estado</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="plan of planTemporal" :key="plan._id">
                      <td class="text-left">{{ getCode(plan._id) }}</td>
                      <td class="text-center">{{ plan.idClient.name }}</td>
                      <td class="text-center">{{ plan.status }}</td>
                      <td class="text-right text-no-wrap">{{ plan.mount | formatCurrency }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <p v-if="planTemporal.length === 0" class="text-center mt-2">No hay resultados</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <v-card class="d-flex flex-column fill-height">
          <v-card-text class="pb-0">
            <div class="d-flex flex-wrap align-center text-h6 text-md-h5">
              Usuarios con Plan
              <v-spacer />
              <span class="monto-total">{{ totalPlanHogar | formatCurrency }}</span>
            </div>
          </v-card-text>
          <v-card-text class="flex-grow-1 pt-2">
            <div class="table-scroll">
              <v-simple-table class="corte-table">
                <template #default>
                  <thead>
                    <tr>
                      <th class="text-left">Código</th>
                      <th class="text-center">Cliente</th>
                      <th class="text-center">Estado</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="plan of planHome" :key="plan._id">
                      <td class="text-left">{{ getCode(plan._id) }}</td>
                      <td class="text-center">{{ plan.idClient.name }}</td>
                      <td class="text-center">{{ plan.status }}</td>
                      <td class="text-right text-no-wrap">{{ plan.mount | formatCurrency }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <p v-if="planHome.length === 0" class="text-center mt-2">No hay resultados</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <recibos-component class="fill-height" @created="getCorteCaja" :items="recibos" />
      </v-col>
    </v-row>

    <!-- Seccion de Modificaciones / Audit Log -->
    <v-row class="mt-4" v-if="auditLogs.length > 0">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <div class="d-flex align-center text-h5">
              <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
              Modificaciones del día
              <v-spacer />
              <v-chip color="error" dark small>{{ auditLogs.length }} cambio(s)</v-chip>
            </div>
          </v-card-text>
          <v-card-text>
            <!-- Desktop: tabla completa -->
            <div class="d-none d-md-block">
              <v-simple-table>
                <template #default>
                  <thead>
                    <tr>
                      <th>Hora</th>
                      <th>Usuario</th>
                      <th>Acci&#243;n</th>
                      <th>Tipo</th>
                      <th>Cliente</th>
                      <th>Concepto</th>
                      <th class="text-right">Anterior</th>
                      <th class="text-right">Nuevo</th>
                      <th class="text-right">Diferencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log of auditLogs" :key="log._id" :class="getLogRowClass(log)">
                      <td>{{ formatTime(log.timestamp) }}</td>
                      <td>{{ log.userId }}</td>
                      <td>
                        <v-chip :color="getActionColor(log.action)" dark x-small>{{ getActionLabel(log.action) }}</v-chip>
                      </td>
                      <td>{{ getCollectionLabel(log.collectionName) }}</td>
                      <td>{{ getClientName(log) }}</td>
                      <td>{{ getConcepto(log) }}</td>
                      <td class="text-right">{{ getMontoAnterior(log) | formatCurrency }}</td>
                      <td class="text-right">{{ getMontoNuevo(log) | formatCurrency }}</td>
                      <td class="text-right font-weight-bold" :class="getDiffClass(log)">
                        {{ getDiferencia(log) | formatCurrency }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot class="audit-summary">
                    <tr v-for="item of auditSummary" :key="item.label" class="summary-row">
                      <td colspan="6" class="text-right font-weight-bold">{{ item.label }} ({{ item.count }})</td>
                      <td class="text-right font-weight-bold">{{ item.totalAnterior | formatCurrency }}</td>
                      <td class="text-right font-weight-bold">{{ item.totalNuevo | formatCurrency }}</td>
                      <td class="text-right font-weight-bold" :class="item.diferencia < 0 ? 'red--text' : item.diferencia > 0 ? 'green--text' : ''">
                        {{ item.diferencia | formatCurrency }}
                      </td>
                    </tr>
                    <tr class="summary-total-row">
                      <td colspan="6" class="text-right font-weight-black text-subtitle-1">TOTAL ({{ auditLogs.length }})</td>
                      <td class="text-right font-weight-black text-subtitle-1">{{ auditTotalAnterior | formatCurrency }}</td>
                      <td class="text-right font-weight-black text-subtitle-1">{{ auditTotalNuevo | formatCurrency }}</td>
                      <td class="text-right font-weight-black text-subtitle-1" :class="auditTotalDiferencia < 0 ? 'red--text' : auditTotalDiferencia > 0 ? 'green--text' : ''">
                        {{ auditTotalDiferencia | formatCurrency }}
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </div>
            <!-- Mobile: cards -->
            <div class="d-block d-md-none">
              <v-card v-for="log of auditLogs" :key="'m-'+log._id" outlined class="mb-2" :class="getLogRowClass(log)">
                <v-card-text class="pa-3">
                  <div class="d-flex justify-space-between align-center mb-1">
                    <span class="text-caption grey--text">{{ formatTime(log.timestamp) }} &middot; {{ log.userId }}</span>
                    <v-chip :color="getActionColor(log.action)" dark x-small>{{ getActionLabel(log.action) }}</v-chip>
                  </div>
                  <div class="font-weight-medium">{{ getCollectionLabel(log.collectionName) }}: {{ getConcepto(log) }}</div>
                  <div class="text-body-2 grey--text text--darken-1" v-if="getClientName(log) !== '-'">Cliente: {{ getClientName(log) }}</div>
                  <div class="d-flex justify-space-between mt-2">
                    <div class="text-caption">
                      <div>Anterior: {{ getMontoAnterior(log) | formatCurrency }}</div>
                      <div>Nuevo: {{ getMontoNuevo(log) | formatCurrency }}</div>
                    </div>
                    <div class="font-weight-bold text-right" :class="getDiffClass(log)">
                      {{ getDiferencia(log) | formatCurrency }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <!-- Resumen mobile -->
              <v-card color="grey lighten-4" class="mt-3" flat>
                <v-card-text class="pa-3">
                  <div class="font-weight-bold text-subtitle-1 mb-2">Resumen de modificaciones</div>
                  <div v-for="item of auditSummary" :key="'ms-'+item.label" class="d-flex justify-space-between py-1" style="border-bottom: 1px solid #e0e0e0">
                    <span class="text-body-2">{{ item.label }} ({{ item.count }})</span>
                    <span class="font-weight-bold" :class="item.diferencia < 0 ? 'red--text' : item.diferencia > 0 ? 'green--text' : ''">{{ item.diferencia | formatCurrency }}</span>
                  </div>
                  <div class="d-flex justify-space-between pt-2 mt-1">
                    <span class="font-weight-black text-subtitle-1">TOTAL ({{ auditLogs.length }})</span>
                    <span class="font-weight-black text-subtitle-1" :class="auditTotalDiferencia < 0 ? 'red--text' : auditTotalDiferencia > 0 ? 'green--text' : ''">{{ auditTotalDiferencia | formatCurrency }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Sale from "@/domain/Sales";
import RecibosComponent from './RecibosComponent.vue';
import { generateCorteCajaPDF } from "@/utils/CorteCajaPDF";

// Mixins
import { FormatsMixin } from "../../mixins/Formats";

export default {
  components: { RecibosComponent },
  name: "CorteCaja",
  mixins: [FormatsMixin],
  mounted() {
    const date = new Date();

    const formattedDate = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'America/Mexico_City'
    });

    const formattedTime = date.toLocaleTimeString('en-CA', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit', 
      hour12: false,
      timeZone: 'America/Mexico_City'
    });

    console.log(formattedDate, formattedTime);

    this.getCorteCaja();
  },
  data: () => ({
    date: new Date().toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'America/Mexico_City'
    }),

    menu: false,
    pdfDialog: false,
    pdfDate: new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/Mexico_City' }),
    isLoading: false,
    isGeneratingPDF: false,
    planHome: [],
    planTemporal: [],
    total: 0,
    recibos: [],
    auditLogs: []
  }),
  computed: {
    totalPlanHogar() {
      return this.planHome.reduce((acc, cur) => acc + cur.mount, 0)
    },
    totalPlanTemporal() {
      return this.planTemporal.reduce((acc, cur) => acc + cur.mount, 0)
    },
    dateFormat() {
      return this.date.split('-').reverse().join('-');
    },
    auditSummary() {
      const groups = {};
      this.auditLogs.forEach(log => {
        const label = this.getCollectionLabel(log.collectionName);
        if (!groups[label]) {
          groups[label] = { label, count: 0, totalAnterior: 0, totalNuevo: 0, diferencia: 0 };
        }
        groups[label].count++;
        groups[label].totalAnterior += this.getMontoAnterior(log);
        groups[label].totalNuevo += this.getMontoNuevo(log);
        groups[label].diferencia += this.getDiferencia(log);
      });
      return Object.values(groups);
    },
    auditTotalAnterior() {
      return this.auditLogs.reduce((acc, log) => acc + this.getMontoAnterior(log), 0);
    },
    auditTotalNuevo() {
      return this.auditLogs.reduce((acc, log) => acc + this.getMontoNuevo(log), 0);
    },
    auditTotalDiferencia() {
      return this.auditTotalNuevo - this.auditTotalAnterior;
    }
  },
  methods: {
    async getCorteCaja() {
      try {
        this.isLoading = true;

        const { receipts, planHome, temporalUsers, auditLog, total } = await Sale.CorteCaja(this.date);
        this.total = total;
        this.planHome = planHome;
        this.planTemporal = temporalUsers;
        this.recibos = receipts;
        this.auditLogs = auditLog || [];
      } catch (error) {
        console.warn(error);
      } finally {
        this.isLoading = false;
      }
    },
    async downloadPDF(targetDate) {
      try {
        this.isGeneratingPDF = true;
        const snapshot = await Sale.Snapshot(targetDate);
        const userData = JSON.parse(localStorage.LCInternet).user;
        generateCorteCajaPDF(snapshot, userData.username);
        this.pdfDialog = false;
      } catch (error) {
        console.warn("Error generando PDF:", error);
      } finally {
        this.isGeneratingPDF = false;
      }
    },
    cambio() {
      this.getCorteCaja();
      this.$refs.menu.save(this.date);
    },
    getCode(_id) {
      return _id.slice(-5);
    },
    // Audit Log helpers
    formatTime(timestamp) {
      if (!timestamp) return '';
      const d = new Date(timestamp);
      return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Mexico_City' });
    },
    getActionColor(action) {
      const colors = { CREATE: 'success', UPDATE: 'warning', DELETE: 'error' };
      return colors[action] || 'grey';
    },
    getActionLabel(action) {
      const labels = { CREATE: 'Creó', UPDATE: 'Modificó', DELETE: 'Eliminó' };
      return labels[action] || action;
    },
    getCollectionLabel(collectionName) {
      const labels = { receipts: 'Recibo', plan_homes: 'Plan Hogar' };
      return labels[collectionName] || collectionName;
    },
    getClientName(log) {
      if (log.newData && log.newData.clientName) return log.newData.clientName;
      if (log.previousData && log.previousData.clientName) return log.previousData.clientName;
      return '-';
    },
    getConcepto(log) {
      if (log.newData && log.newData.concepto) return log.newData.concepto;
      if (log.previousData && log.previousData.concepto) return log.previousData.concepto;
      return '-';
    },
    getMontoAnterior(log) {
      if (!log.previousData) return 0;
      return log.previousData.total || log.previousData.mount || 0;
    },
    getMontoNuevo(log) {
      if (!log.newData) return 0;
      return log.newData.total || log.newData.mount || 0;
    },
    getDiferencia(log) {
      return this.getMontoNuevo(log) - this.getMontoAnterior(log);
    },
    getDiffClass(log) {
      const diff = this.getDiferencia(log);
      if (diff < 0) return 'red--text';
      if (diff > 0) return 'green--text';
      return '';
    },
    getLogRowClass(log) {
      if (log.action === 'DELETE') return 'red lighten-5';
      if (log.changes && log.changes.total) return 'orange lighten-5';
      if (log.changes && log.changes.mount) return 'orange lighten-5';
      return '';
    }
  }
};
</script>


<style lang="scss" scoped>
.input-date {
  max-width: 200px;
  width: 100%;
}

.pdf-btn {
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 500;
}

@media (max-width: 600px) {
  .input-date {
    max-width: 100%;
  }

  .pdf-btn {
    width: 100%;
  }
}

.monto-total {
  font-weight: 600;
  white-space: nowrap;
}

.table-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.corte-table ::v-deep {
  tbody tr:nth-child(even) {
    background-color: #f5f5f5;
  }
}

.corte-row .fill-height {
  height: 100%;
}

.audit-summary .summary-row td {
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}

.audit-summary .summary-total-row td {
  background-color: #e8eaf6;
  border-top: 2px solid #3f51b5;
}
</style>
